import React from 'react';

import { Nullable } from '@clearverify/types';

export type VerificationRequestProcessingContextValue = {
  isSubmitting: boolean;
  startSubmitting: () => void;
  stopSubmitting: () => void;

  isVerifierResponding: (inboxItemId: Nullable<string>) => boolean;
  startVerifierResponding: (inboxItemId: string) => void;
  stopVerifierResponding: (inboxItemId: string) => void;

  resetState: () => void;
};

export const VerificationRequestProcessingContext = React.createContext(
  {} as VerificationRequestProcessingContextValue,
);
